"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourceLabelsFailure = exports.resourceLabelsSuccess = exports.resourceLabelsLoading = exports.getResourceLabels = void 0;

var _constants = require("./constants");

var getResourceLabels = function getResourceLabels(consumerEntityId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = {
    consumerEntityId: consumerEntityId,
    params: params
  };
  return {
    type: _constants.ResourceLabelsType.RESOURCE_LABELS_REQUEST,
    payload: payload
  };
};

exports.getResourceLabels = getResourceLabels;

var resourceLabelsLoading = function resourceLabelsLoading() {
  return {
    type: _constants.ResourceLabelsType.RESOURCE_LABELS_LOADING
  };
};

exports.resourceLabelsLoading = resourceLabelsLoading;

var resourceLabelsSuccess = function resourceLabelsSuccess(payload) {
  return {
    type: _constants.ResourceLabelsType.RESOURCE_LABELS_SUCCESS,
    payload: payload
  };
};

exports.resourceLabelsSuccess = resourceLabelsSuccess;

var resourceLabelsFailure = function resourceLabelsFailure(reason) {
  return {
    type: _constants.ResourceLabelsType.RESOURCE_LABELS_FAILURE,
    payload: reason
  };
};

exports.resourceLabelsFailure = resourceLabelsFailure;